import { Machine, assign } from "xstate";
import { useMachine } from "@xstate/react";
import { useEffect, useMemo } from "react";
import axios from "axios";

const instance = axios.create({
  baseURL: "https://content.desigualdadessalud.org/v1/"
});

function getContent(page) {
  return instance.get(`/content/${page}`).then(response => response.data);
}

function saveContent(page, content) {
  return instance
    .post(`/content/${page}`, content)
    .then(response => response.data);
}

const noop = () => {};

function createMachine(page) {
  return Machine(
    {
      id: "promise",
      initial: "idle",
      context: {
        content: undefined,
        page: undefined,
        error: undefined,
        onUpdate: noop,
        onError: noop
      },
      states: {
        idle: {
          on: {
            FETCH: {
              target: "loading",
              actions: assign({ page: (context, event) => event.page })
            }
          }
        },
        loading: {
          invoke: {
            id: "getContent",
            src: (context, event) => {
              return getContent(event.page);
            },
            onDone: {
              target: "success",
              actions: assign({ content: (context, event) => event.data })
            },
            onError: {
              target: "failure",
              actions: assign({ error: (context, event) => event.data })
            }
          }
        },
        success: {
          on: {
            UPDATE: "update",
            RESTART: {
              target: "idle"
            }
          }
        },
        update: {
          invoke: {
            id: "saveContent",
            src: (context, event) => saveContent(event.page, event.content),
            onDone: {
              target: "success",
              actions: [
                assign({ content: (context, event) => event.data }),
                "onUpdate"
              ]
            },
            onError: {
              target: "failure",
              actions: [
                assign({ error: (context, event) => event.data }),
                "onError"
              ]
            }
          }
        },
        failure: {
          on: {
            RETRY: "loading"
          }
        }
      }
    },
    {
      actions: {
        onUpdate: context => context.onUpdate(),
        onError: context => context.onError()
      }
    }
  );
}

export default function useContent(
  page,
  { onUpdate = noop, onError = noop } = {}
) {
  const promiseMachine = useMemo(() => createMachine(page), [page]);
  const [current, send] = useMachine(promiseMachine, {
    context: {
      page,
      onError,
      onUpdate
    },
    immediate: true
  });
  useEffect(() => {
    send("FETCH", { page });
    return () => {
      send("RESTART");
    };
  }, [page]);
  const refetch = () => {
    if (current.matches("success")) {
      send("REFETCH");
    }
  };

  const update = (content, page) => {
    if (current.matches("success")) {
      send("UPDATE", { content, page });
    }
  };

  return {
    data: current.context.content,
    error: current.context.error,
    refetch,
    update,
    loading: current.matches("loading") || current.matches("idle")
  };
}



// WEBPACK FOOTER //
// ./src/components/static/data.js